import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getResourceList } from '../../models/BaseModel'
import { ImageReplacementAnchor, FooterNavigation, SocialLinks, BlankErrorBoundary } from '@scrippsproduct/networks-ui-library'
import useAddScriptTags from '@scrippsproduct/networks-ui-library/dist/hooks/useAddScriptTags'
import useSourcepointPrivacyTrigger from '@scrippsproduct/networks-ui-library/dist/hooks/useSourcepointPrivacyTrigger'

import './../../scss/Footer.scss'

export default function Footer() {
    const [navSections, setNavSections] = useState([])
    const [socialLinks, setSocialLinks] = useState([])
    const {isSuccess, data} = useQuery({
        queryKey: ['footer', {resourceName: 'footer'}], 
        queryFn: getResourceList
    });

    useAddScriptTags([
        {
            id: 'cmp',
            textContent: `(function () { var e = false; var c = window; var t = document; function r() { if (!c.frames["__uspapiLocator"]) { if (t.body) { var a = t.body; var e = t.createElement("iframe"); e.style.cssText = "display:none"; e.name = "__uspapiLocator"; a.appendChild(e) } else { setTimeout(r, 5) } } } r(); function p() { var a = arguments; __uspapi.a = __uspapi.a || []; if (!a.length) { return __uspapi.a } else if (a[0] === "ping") { a[2]({ gdprAppliesGlobally: e, cmpLoaded: false }, true) } else { __uspapi.a.push([].slice.apply(a)) } } function l(t) { var r = typeof t.data === "string"; try { var a = r ? JSON.parse(t.data) : t.data; if (a.__cmpCall) { var n = a.__cmpCall; c.__uspapi(n.command, n.parameter, function (a, e) { var c = { __cmpReturn: { returnValue: a, success: e, callId: n.callId } }; t.source.postMessage(r ? JSON.stringify(c) : c, "*") }) } } catch (a) { } } if (typeof __uspapi !== "function") { c.__uspapi = p; __uspapi.msgHandler = l; c.addEventListener("message", l, false) } })();`,
            insertInHead: true,
        },
        {
            id: 'gpp',
            textContent: `window.__gpp_addFrame=function(e){if(!window.frames[e])if(document.body){var t=document.createElement("iframe");t.style.cssText="display:none",t.name=e,document.body.appendChild(t)}else window.setTimeout(window.__gpp_addFrame,10,e)},window.__gpp_stub=function(){var e=arguments;if(__gpp.queue=__gpp.queue||[],__gpp.events=__gpp.events||[],!e.length||1==e.length&&"queue"==e[0])return __gpp.queue;if(1==e.length&&"events"==e[0])return __gpp.events;var t=e[0],p=e.length>1?e[1]:null,s=e.length>2?e[2]:null;if("ping"===t)p({gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["2:tcfeuv2","5:tcfcav1","6:uspv1","7:usnatv1","8:uscav1","9:usvav1","10:uscov1","11:usutv1","12:usctv1"],cmpId:0,sectionList:[],applicableSections:[],gppString:"",parsedSections:{}},!0);else if("addEventListener"===t){"lastId"in __gpp||(__gpp.lastId=0),__gpp.lastId++;var n=__gpp.lastId;__gpp.events.push({id:n,callback:p,parameter:s}),p({eventName:"listenerRegistered",listenerId:n,data:!0,pingData:{gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["2:tcfeuv2","5:tcfcav1","6:uspv1","7:usnatv1","8:uscav1","9:usvav1","10:uscov1","11:usutv1","12:usctv1"],cmpId:0,sectionList:[],applicableSections:[],gppString:"",parsedSections:{}}},!0)}else if("removeEventListener"===t){for(var a=!1,i=0;i<__gpp.events.length;i++)if(__gpp.events[i].id==s){__gpp.events.splice(i,1),a=!0;break}p({eventName:"listenerRemoved",listenerId:s,data:a,pingData:{gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["2:tcfeuv2","5:tcfcav1","6:uspv1","7:usnatv1","8:uscav1","9:usvav1","10:uscov1","11:usutv1","12:usctv1"],cmpId:0,sectionList:[],applicableSections:[],gppString:"",parsedSections:{}}},!0)}else"hasSection"===t?p(!1,!0):"getSection"===t||"getField"===t?p(null,!0):__gpp.queue.push([].slice.apply(e))},window.__gpp_msghandler=function(e){var t="string"==typeof e.data;try{var p=t?JSON.parse(e.data):e.data}catch(e){p=null}if("object"==typeof p&&null!==p&&"__gppCall"in p){var s=p.__gppCall;window.__gpp(s.command,(function(p,n){var a={__gppReturn:{returnValue:p,success:n,callId:s.callId}};e.source.postMessage(t?JSON.stringify(a):a,"*")}),"parameter"in s?s.parameter:null,"version"in s?s.version:"1.1")}},"__gpp"in window&&"function"==typeof window.__gpp||(window.__gpp=window.__gpp_stub,window.addEventListener("message",window.__gpp_msghandler,!1),window.__gpp_addFrame("__gppLocator"));`,
            insertInHead: true,
        },
        {
            id: 'sp',
            textContent: `window._sp_queue = [];
            window._sp_ = {
                config: {
                    accountId: 1995,
                    baseEndpoint: 'https://cdn.privacy-mgmt.com',
                    usnat: {
                        includeUspApi: true,
                    },
                    events: {
                        onMessageReady: function() {
                            console.log('[event] onMessageReady', arguments);
                        },
                        onMessageReceiveData: function() {
                            console.log('[event] onMessageReceiveData', arguments);
                        },
                        onSPPMObjectReady: function() {
                            console.log('[event] onSPPMObjectReady', arguments);
                        },
                        onSPReady: function() {
                            console.log('[event] onSPReady', arguments);
                        },
                        onError: function() {
                            console.log('[event] onError', arguments);
                        },
                        onMessageChoiceSelect: function() {
                            console.log('[event] onMessageChoiceSelect', arguments);
                        },
                        onConsentReady: function(consentUUID, euconsent) {
                            console.log('[event] onConsentReady', arguments);
                        },
                        onPrivacyManagerAction: function() {
                            console.log('[event] onPrivacyManagerAction', arguments);
                        },
                        onPMCancel: function() {
                            console.log('[event] onPMCancel', arguments);
                        },
                    },
                },
            };`,
            insertInHead: true
        },
        {
            id: 'sp-iframe',
            src: 'https://cdn.privacy-mgmt.com/unified/wrapperMessagingWithoutDetection.js',
            insertInHead: true
        }
    ]);
    useSourcepointPrivacyTrigger({})

    useEffect(() => {
        if (isSuccess) {
            setNavSections(data.get('navSections'))
            setSocialLinks(data.get('socialLinks'))
        }
    }, [isSuccess, data])

    return (
        <footer className="main-footer">
            <content-constrainer>
                <div className="footer-logo">
                    <ImageReplacementAnchor href={`/`} 
                        image={{
                            url: 'https://ewscripps.brightspotcdn.com/a1/12/e4d1ce984940b4cb7f1ac896a5f7/sports-logo-2x.png', 
                            width: 528, 
                            height: 100
                        }} 
                        height={3.5}
                        baselineAdjustment={0.7}
                    />
                </div>
                <div className="footer-nav-wrapper">
                    { (isSuccess && navSections.length > 0) && 
                        <BlankErrorBoundary>
                            <FooterNavigation sections={navSections} />
                        </BlankErrorBoundary> 
                    }
                    { (isSuccess && socialLinks.length > 0) && 
                        <BlankErrorBoundary>
                            <SocialLinks size={1.5} showHeader={true} platforms={socialLinks}/>
                        </BlankErrorBoundary> 
                    }
                </div>
                <div className="copyright-notice">
                    {`© ${new Date().getFullYear()} E.W. Scripps Company, all rights reserved.`}
                </div>
            </content-constrainer>
        </footer>
    )
}
